// The one place that decides where "nowhere in particular" lands after sign-in. Reached from
// index.js (a redirect sign-in that had no saved deep link) and from /login when already signed
// in. Anyone who followed a link never comes here — restorePostAuthRedirect put them back first.
import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { listProjectsSilent, postSignupIntent } from "../utils/api";
import { landingFor } from "../utils/landing";

export default function Start() {
  const [target, setTarget] = useState(null);
  const [params] = useSearchParams();
  const from = { product: params.get("product") || undefined, plan: params.get("plan") || undefined };
  useEffect(() => {
    let alive = true;
    // Tell the backend which product a new account came for, so its welcome email matches. Fire and
    // forget: the backend ignores it for existing accounts, and a failure must never hold up routing.
    if (from.product) postSignupIntent(from).catch(() => {});
    if (from.product === "analytics") { setTarget(landingFor([], from)); return undefined; }
    listProjectsSilent()
      .then((p) => { if (alive) setTarget(landingFor(p, from)); })
      .catch(() => { if (alive) setTarget(landingFor([], from)); });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (target) return <Navigate to={target} replace />;
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "#0b0b0f" }}>
      <CircularProgress sx={{ color: "#2da894" }} />
    </Box>
  );
}
